import { service } from '@/common/request/request.js'

// 取出全部的金额，用于提现等页面
export function takebackAmount(data = {}) {
  return service({
    url: '/loged/withdrawGames',
    method: 'post',
    data
  })
}

// 刷新账户余额
export function refreshGameAccount(data = {}) {
  return service({
    url: '/logged/refreshGameAccount',
    method: 'post',
    data
  })
}

// 添加银行卡
export function addBankCard(data = {}) {
  return service({
    url: '/loged/addBankCard',
    method: 'post',
    data
  })
}

// 删除银行卡
export function deleteBank(data = {}) {
  return service({
    url: '/loged/deleteBank',
    method: 'post',
    data
  })
}

// 获取银行卡列表
export function getbankCardList(data = {}) {
  return service({
    url: '/loged/bankCardList',
    method: 'post',
    data
  })
}
//获取取款列表
export function getRupeelinkList(data = {}) {
    return service({
      url: '/loged/rupeelinkList',
      method: 'post',
      data
    })
  }
// 获取USDT地址列表
export function getUsdtBankList(data = {}) {
  return service({
    url: '/loged/usdtList',
    method: 'post',
    data
  })
}

// 银行名称列表
export function getbankNameList(data = {}) {
  return service({
    url: '/logged/inBanks/list',
    method: 'post',
    data
  })
}

// 验证银行卡信息
export function checkBankInfo(data = {}) {
  return service({
    url: '/loged/checkBankCard',
    method: 'post',
    data
  })
}

// 获取支付类型
export function getPayType(data = {}, type = 1) {
  const urls = ['/loged/payType', '/loged/payType/v2']
  return service({
    url: urls[type],
    method: 'post',
    data
  })
}

// 获取支付的内容
export function getPayConfig(data = {}) {
  return service({
    url: '/loged/payConfig/v2',
    method: 'post',
    data
  })
}

// 印度存款接口
export function hiInDeposit(data = {}) {
  return service({
    url: '/bankpay/inPayOrder',
    method: 'post',
    data
  })
}

// 发送提款密码验证码 / 修改邮箱验证码
export function sendYzm(data = {}) {
  return service({
    url: '/loged/sendWithdrawYZM',
    method: 'post',
    data
  })
}

// 提款密码
export function withdrawPwd(data = {}, type = 0) {
  // 0 设置提款密码 1 修改提款密码
  const urls = ['/loged/setWithdrawPW', '/loged/updateWithdrawPW']
  return service({
    url: urls[type],
    method: 'post',
    data
  })
}

// 申请提现
export function applyWithdraw(data = {}) {
  return service({
    url: '/loged/applyWithdraw',
    method: 'post',
    data
  })
}

// 向游戏平台转账
export function transferAccountsToGame(data = {}) {
  return service({
    url: '/loged/deposit',
    method: 'post',
    data
  })
}

// 向中心钱包转账
export function transferAccountsToWallet(data = {}) {
  return service({
    url: '/loged/withdraw',
    method: 'post',
    data
  })
}

// 最低取款限额
export function getMinWithdrawal(data = {}) {
  return service({
    url: '/loged/minLimit',
    method: 'post',
    data
  })
}

// 查询会员账户锁定金额记录
export function getUserLockAmountList(data = {}) {
  return service({
    url: '/loged/queryUserLockAmount',
    method: 'post',
    data
  })
}

// 会员自助解锁锁定金额
export function unlockAmount(data = {}) {
  return service({
    url: '/loged/selfUnlockAmount',
    method: 'post',
    data
  })
}

// 我的账单列表
export function getBalanceList(data = {}) {
  return service({
    url: '/loged/myBalanceList',
    method: 'post',
    data
  })
}

// 我的账单详情
export function getBalanceDetails(data = {}) {
  return service({
    url: '/loged/balanceDetail',
    method: 'post',
    data
  })
}

// 会员存款订单列表查询
export function getUserDepositOrder(data = {}) {
  return service({
    url: '/loged/selectUserPayOrderList',
    method: 'post',
    data
  })
}

// 获取所有提现的申请
export function getWithdrawList(data = {}) {
  return service({
    url: '/loged/withdrawList',
    method: 'post',
    data
  })
}

// 获取最近支付记录列表
export function getDepositOrderList(data = {}) {
  return service({
    url: '/logged/depositOrder/list',
    method: 'post',
    data
  })
}

// 取消最近支付订单
export function cancelOrder(data = {}) {
  return service({
    url: '/logged/cancelOrder',
    method: 'post',
    data
  })
}

// 获取INRUpay取款列表
export function getInrupaylink(data = {}) {
    return service({
      url: '/loged/inrupayList',
      method: 'post',
      data
    })
}


// WEBPACK FOOTER //
// ./src/common/api/Amount.js